import { Turnstile } from '@marsidev/react-turnstile'
import {
  ContactPage as ContactPageComponent,
  createBackendContactFormHandler,
} from '@roselabs-io/saas-shell'
import { Header, Footer } from '../components'
import { useAuth } from '../lib/auth'

// Create the contact form handler that posts to our backend (which proxies to Sage)
const handleContactSubmit = createBackendContactFormHandler({
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8003',
})

export default function ContactPage() {
  const { user, teamId } = useAuth()

  // Dashboard link for logged-in users
  const dashboardLink = teamId ? `/t/${teamId}/dashboard` : undefined

  return (
    <ContactPageComponent
      productName="Falcon"
      header={<Header />}
      footer={<Footer />}
      onSubmit={handleContactSubmit}
      turnstileSiteKey={import.meta.env.VITE_TURNSTILE_SITE_KEY}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      TurnstileComponent={Turnstile as any}
      description="Have questions about Falcon? We'd love to hear from you. Send us a message and we'll respond as soon as possible."
      backLink="/"
      dashboardLink={dashboardLink}
      user={user ? { name: user.name, email: user.email } : undefined}
    />
  )
}
